import {Ng1Controller, StateService, TargetState, Transition} from "@uirouter/angularjs";
import {DataHubService} from "../modules/DataHubModule";
import {DisposeBag} from "../modules/DisposeBag";
import {DebounceFactory} from "../modules/DebounceModule";
import {IToasterService} from "ngtoaster";
import {SpinnerService} from "../modules/SpinnerModule";
import {QbAdditionalContactDto} from "../model/QbAdditionalContactDto";
import {QbCustomerContactDto} from "../model/QbCustomerContactDto";
import * as angular from "angular";
import {ConfigService} from "../modules/ConfigModule";

export default class ContactEditController implements Ng1Controller {
    private resolve;
    private close: () => void;
    private contact: QbCustomerContactDto;
    private disposeBag = new DisposeBag();
    private contactNames = ['Main Phone', 'Work Phone', 'Home Phone', 'Mobile', 'Fax', 'Alt. Phone', 'Alt. Mobile', 'Alt. Fax',
        'Main Email', 'CC Email', 'Alt. Email 1', 'Alt. Email 2', 'Website', 'LinkedIn', 'Facebook', 'Twitter',
        'URL 1', 'URL 2', 'URL 3', 'URL 4', 'Skype ID', 'Other 1', 'Other 2', 'Other 3'];
    private contactNameDefaults = ['Main Phone', 'Work Phone', 'Mobile', 'Fax', 'Main Email', 'CC Email', 'Website', 'Other 1'];

    $onInit(): void {
        console.log('$onInit');
        if(this.resolve.contact) {
            this.contact = angular.copy(this.resolve.contact);
        } else {
            this.contact = new QbCustomerContactDto();
            this.contact.qbCustomerGuid = this.resolve.customerGuid;
        }
        this.populate();
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        this.disposeBag.finalize();
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
        console.debug('uiOnParamsChanged', newValues, $transition$);
        this.$stateParams = newValues;
    }

    constructor(private $dataHub: DataHubService,
                private $state: StateService,
                private $stateParams: any,
                private $debounce: DebounceFactory,
                private toaster: IToasterService,
                private $spinner: SpinnerService,
                private $config: ConfigService) {
        $dataHub.onConnected(this.refresh, this.disposeBag);
    }
    refresh = () => {
        if (!this.$dataHub.isConnected) return;
        this.refreshDebounce();
    };

    refreshDebounce = this.$debounce(() => {
    }, 1000, true);


    populate = () => {
        if (!this.contact.additionalContacts) this.contact.additionalContacts = [];
        while (this.contact.additionalContacts.length < 8) {
            let inUse = this.contact.additionalContacts.map(x => x.contactName);
            let next = this.contactNameDefaults.filter(name => inUse.some(x => x == name) == false)[0];
            let contact = new QbAdditionalContactDto();
            contact.rowId = this.contact.additionalContacts.length;
            contact.contactName = next;
            this.contact.additionalContacts.push(contact);
        }
    }

    getContactNames = (current: QbAdditionalContactDto) => {
        let inUse = this.contact.additionalContacts.filter(x => x != current).map(x => x.contactName);
        return this.contactNames.filter(name => inUse.some(x => x == name) == false);
    }

    save = () => {
        this.$dataHub.contactSave(this.contact)
            .then(() => this.close())
            .catch(this.$dataHub.defaultErrorHandler);
    }

    delete = () => {
        this.$dataHub.contactDelete(this.contact)
            .then(() => this.close())
            .catch(this.$dataHub.defaultErrorHandler);
    }

    get canDelete(): boolean {
        if(this.resolve.contact.qbPrimary) return false;
        if(this.contact.guid) return true;
        return false;
    }

}
